<template>
  <c-select
    class="CoinSelect"
    :promptText="$t('assets.addressMent.coin')"
    :errorHave="false"
    :value="myValue"
    :options="options"
    :filterable="true"
    newStyleFormat
    type="slot"
    fill
    @onChanges="selectLineChange">
      <div slot="options" slot-scope="scope" class="optionItem">
        <div class="left">
          <img class="imgIcon" :src="scope.row.img"/>
          <span class="coinName">{{ scope.row.value }}</span>
          <span class="coinName">{{ currentCoinInfo[scope.row.value] && currentCoinInfo[scope.row.value].longName }}</span>
        </div>
        <div class="right">
          <span class="coinStatus" v-if="deposit">{{ scope.row.depositOpen ? '' : $t('assets.suspend') }}</span>
          <span class="coinStatus" v-if="withdraw">{{ scope.row.withdrawOpen ? '' : $t('assets.suspend') }}</span>
        </div>
      </div>
    </c-select>
</template>

<script>
export default {
  name: 'AssetCoinSelect',
  props: {
    value: {
      type: String,
      default: '',
    },
    // 是否初始化第一个symbol
    init: {
      type: Boolean,
      default: false,
    },
    // 展示充值状态
    deposit: {
      type: Boolean,
      default: false,
    },
    // 展示提现状态
    withdraw: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      myValue: '',
      options: [],
    };
  },
  computed: {
    exchangeData() {
      return this.$store.state.assets.exchangeData;
    },
    market() {
      return this.$store.state.baseData.market;
    },
    currentCoinInfo() {
      const currentCoinInfo = {};
      const { coinSymbolIntroduce } = this.$store.state.baseData;
      coinSymbolIntroduce.forEach((el) => {
        currentCoinInfo[el.coinSymbol] = el;
      });
      return currentCoinInfo;
    },
  },
  watch: {
    exchangeData: {
      immediate: true,
      handler() {
        this.setOptions();
      },
    },
    market: {
      immediate: true,
      handler() {
        this.setOptions();
      },
    },
    value: {
      immediate: true,
      handler() {
        this.setMyValue();
      },
    },
  },
  mounted() {
    this.setOptions();
  },
  methods: {
    setOptions() {
      if (!this.exchangeData || !this.market) {
        return;
      }
      const list = [];
      const allCoinMap = this.exchangeData.allCoinMap || [];
      const coinList = this.market.coinList;
      Object.keys(allCoinMap).forEach((key) => {
        const coinKey = key.toUpperCase();
        const coinListItem = coinList[coinKey];
        const coinMapItem = allCoinMap[coinKey];
        if (coinListItem) {
          list.push({
            img: coinListItem.icon,
            value: coinListItem.showName,
            code: coinKey,
            depositOpen: coinMapItem.depositOpen,
            withdrawOpen: coinMapItem.withdrawOpen,
          });
        }
      });
      this.options = list;
      if (this.init && !this.value && list.length > 0) {
        this.myValue = list[0].code;
        this.onUpdate();
      }
    },

    setMyValue() {
      try {
        this.myValue = this.value;
      } catch (error) {
        this.myValue = '';
      }
    },

    selectLineChange(item) {
      this.myValue = item.code;
      this.onUpdate();
    },

    onUpdate() {
      this.$emit('input', this.myValue);
      this.$emit('change', this.myValue);
    },
  },
};
</script>
<style lang="scss" scoped>
.optionItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 40px;
  height: 40px;
  overflow: hidden;

  .left {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .imgIcon {
    width: 18px;
    height: 18px;
  }

  .coinName {
    font-family: 'Alpex';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
  }

  .coinStatus {
    font-family: 'Alpex';
    font-style: normal;
    font-size: 14px;
    color: #878999;
  }
}

/deep/ .blue-bg {
  .coinStatus {
    color: white;
  }
}
</style>
